import "@fontsource/orbitron/400.css"
import "@fontsource/orbitron/900.css"
import "@fontsource/noto-sans-tc/400.css"
import "@fontsource/noto-sans-tc/500.css"
import "@fontsource/noto-sans-tc/600.css"
import "@fontsource/noto-sans-tc/700.css"
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import GradientBlinds from './js/gradient_blinds';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  // header dropdown
  $('.header-menu-link.dropdown').on('click', function() {
    $(this).toggleClass('active');
  })

  // 錨點連結平滑移動 (所有包含 # 的錨點，但排除只有 # 的錨點)
  let $nav_height = $('#header').innerHeight();
  $('a[href*=\\#]:not([href=\\#])').on('click', function() {
      var target = $(this.hash);
      $('html, body').animate({
        scrollTop: target.offset().top - ($nav_height * 2.5)
      }, 1000);
      return false;
  });

  
  // 首頁 Hero banner (only 電腦版)
  let screenWindth = $(window).innerWidth();
  const gradientCanvasWrap = document.querySelector('#js-gradient-canvas-wrap');
  let GradientBlindsCanvas = null;
  // 初始化特效
  function buildGradientBlindsCanvas() {
    if ( !GradientBlindsCanvas ) {
      GradientBlindsCanvas = new GradientBlinds(gradientCanvasWrap, {
        gradientColors: ['#7AABFF', '#004BD2'],
        shineDirection: 'left',  // Light Direction
        angle: 154,              // Blinds Angle
        noise: 0,                // Noise Amount
        blindCount: 11,          // Blinds Count
        blindMinWidth: 10,       // Min Blind W
        spotlightRadius: 0.4,    // Spot Radius
        distortAmount: 20,       // Distort
        mouseDampening: 0.15,    // Mouse Damp
      });
    }
  }
  // 銷毀特效
  function destroyGradientBlindsCanvas() {
    if ( GradientBlindsCanvas ) {
      GradientBlindsCanvas.destroy();
      GradientBlindsCanvas = null;
    }
  }
  if ( screenWindth >= 801 && gradientCanvasWrap ) {
    buildGradientBlindsCanvas();
  }
  let homeGradientBlindsResizeTimer; // resize計時器
  $(window).on('resize', function() {
    clearTimeout(homeGradientBlindsResizeTimer);
    homeGradientBlindsResizeTimer = setTimeout(function () {
      screenWindth = $(window).innerWidth();
      if ( screenWindth >= 801 && gradientCanvasWrap ) {
        buildGradientBlindsCanvas();
      } else {
        destroyGradientBlindsCanvas();
      }
    }, 500);
  });  

  // 首頁 Hero 後方區塊背景透明度漸變效果
  const $homeSection = $('#js-hero-section');
  let homeSection_h = $homeSection.height();
  function updateHomeBgOpacity() {
    let scrolled = $(window).scrollTop();
    if ( scrolled <= homeSection_h ) {
      let opacity = (scrolled / homeSection_h) < 0.9 ? (scrolled / homeSection_h) : 0.9;
      document.querySelector('#js-home-page').style.setProperty('--bg-opacity', opacity);
    } else {
      document.querySelector('#js-home-page').style.setProperty('--bg-opacity', 0.9);
    }
  }
  if ( $homeSection.length != 0 ) {
    updateHomeBgOpacity();
  }
  $(window).on('scroll', function () {
    if ( $homeSection.length != 0 ) {
      updateHomeBgOpacity();
    }
  });
  let homeBGResizeTimer; // resize計時器
  $(window).on('resize', function() {
    clearTimeout(homeBGResizeTimer);
    homeBGResizeTimer = setTimeout(function () {
      if ( $homeSection.length != 0 ) {
        homeSection_h = $homeSection.height();
      }
    }, 200);
  });

  // 首頁-產品輪播
  var homeProductsSwiper = new Swiper("#homeProductsSwiper", {
    slidesPerView: 1,
    effect: 'fade',
    navigation: {
      prevEl: ".home-products-swiper-wrap .swiper-button-prev",
      nextEl: ".home-products-swiper-wrap .swiper-button-next",
    },
  });

  // 首頁-最新消息輪播
  var homeNewsSwiper = new Swiper("#homeNewsSwiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      prevEl: ".home-news-swiper-wrap .swiper-button-prev",
      nextEl: ".home-news-swiper-wrap .swiper-button-next",
    },
    pagination: {
      el: ".home-news-swiper-wrap .swiper-pagination",
      clickable: false,
    },
    breakpoints: {
      1025: { // >= 1025px 時
        slidesPerView: 3.5,
        spaceBetween: 38,
        slidesOffsetAfter: 80,
      },
      641: { // >= 641px 時
        slidesPerView: 2.5,
        spaceBetween: 38,
        slidesOffsetAfter: 60,
      }
    },
  });

  // 產品內頁-產品輪播
  if ( $('#productSlider').length != 0 ) {
    // 產品縮圖輪播
    var productThumbsSlider = new Swiper("#productThumbsSlider", {
      direction: 'vertical',
      observer: true, 
      observeParents: true,
      spaceBetween: 9,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".product-thumbs-slider-wrap .swiper-button-next",
        prevEl: ".product-thumbs-slider-wrap .swiper-button-prev",
      },
      breakpoints: {
        0: {
          direction: 'horizontal',
          slidesPerView: 4,
        },
        641: {  // >= 641
          direction: 'horizontal',
          slidesPerView: 5,
        },
        801: {  // >= 801
          direction: 'vertical',
          slidesPerView: 4,
        },
      },
    });
    // 產品大圖輪播
    var productSlider = new Swiper("#productSlider", {
      observer: true, 
      observeParents: true,
      effect: 'fade',
      thumbs: {
        swiper: productThumbsSlider,
      },
    });
  }

  // 彙總頁分類Tabs
  if ( $('#pageCateSwiper').length != 0 ) {
    var swiper = new Swiper("#pageCateSwiper", {
      slidesPerView: "auto",
      spaceBetween: 0,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".page-cate-group .swiper-button-next",
        prevEl: ".page-cate-group .swiper-button-prev",
      },
    });
  }

  // 合作夥伴 - 補足跑馬燈輪播的元素數量
  function cloneSlidesItem($slider) {
    let $container = $slider;
    let $wrapper = $container.find('.swiper-wrapper');
    let $slides = $container.find('.swiper-slide');
    if ( $slides.length === 0 ) return;
    let screenWidth = $(window).width();
    let totalWidth = 0;
    $slides.each(function() {
      totalWidth += $(this).outerWidth(true);
    });
    if ( totalWidth < screenWidth * 2 ) {
      let repeatCount = Math.ceil((screenWidth * 2) / totalWidth);
      for (let i = 0; i < repeatCount; i++) {
        $wrapper.append($slides.clone());
      }
    }
  }
  // 合作夥伴
  if ( $('#partnersToRightSlider').length != 0 ) {
    // 合作夥伴 - 向左跑馬燈輪播
    cloneSlidesItem( $('#partnersToLeftSlider') );
    var partnersToLeftSlider = new Swiper("#partnersToLeftSlider", {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
      allowTouchMove: false,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
    // 合作夥伴 - 向右跑馬燈輪播
    cloneSlidesItem( $('#partnersToRightSlider') );
    var partnersToRightSlider = new Swiper("#partnersToRightSlider", {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
      allowTouchMove: false,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true, // 反向
      },
    });
  }

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });
});

